import { useEffect, useState } from "react";
import axios from "axios";
import { Navbar } from "../components/shop/Navbar";
import { Hero } from "../components/shop/Hero";
import { Benefits } from "../components/shop/Benefits";
import { EverydayEssentials } from "../components/shop/EverydayEssentials";
import { ShopByCategory } from "../components/shop/ShopByCategory";
import { Showcase } from "../components/shop/Showcase";
import { HairCareNext } from "../components/shop/HairCareNext";
import { BodyCare } from "../components/shop/BodyCare";
import { Results } from "../components/shop/Results";
import { Reviews } from "../components/shop/Reviews";
import { WhyCelusta } from "../components/shop/WhyCelusta";
import { HowTo } from "../components/shop/HowTo";
import { Ingredients } from "../components/shop/Ingredients";
import { FAQ } from "../components/shop/FAQ";
import { JudgeMeReviews } from "../components/shop/JudgeMeReviews";
import { JUDGEME_REVIEWS_VISIBLE } from "../lib/judgeme";
import { Footer } from "../components/shop/Footer";
import { BagDrawer } from "../components/shop/BagDrawer";
import { StickyBuyBar } from "../components/shop/StickyBuyBar";
import { trackViewContent } from "../lib/metaPixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    let base = null;
    const merge = (shopify) =>
      setProduct((prev) => {
        const combined = { ...(base || prev || {}) };
        if (shopify) {
          const amount = parseFloat(shopify.price);
          if (!Number.isNaN(amount)) combined.price = amount;
          if (shopify.currency) combined.currency = shopify.currency;
          if (shopify.product_id) combined.shopifyProductId = shopify.product_id;
          if (shopify.variant_id) combined.shopifyVariantId = shopify.variant_id;
        }
        trackViewContent(combined);
        return combined;
      });

    axios
      .get(`${API}/product`)
      .then((res) => {
        base = res.data;
        setProduct((prev) => ({ ...(res.data || {}), ...(prev || {}) }));
      })
      .catch(() => {});

    // Shopify is the source of truth for price/currency (US market); silently keeps fallback price on failure.
    axios
      .get(`${API}/shopify/product/CELUSTA-PCS-200`)
      .then((res) => merge(res.data))
      .catch(() => {});
  }, []);

  return (
    <div className="relative">
      <Navbar />
      <Hero />
      <EverydayEssentials product={product} />
      <ShopByCategory />
      <Benefits />
      <Results />
      <Showcase product={product} />
      {JUDGEME_REVIEWS_VISIBLE && <JudgeMeReviews />}
      <HairCareNext />
      <Reviews />
      <HowTo />
      <Ingredients />
      <BodyCare />
      <WhyCelusta />
      <FAQ />
      <Footer />
      <BagDrawer product={product} />
      <StickyBuyBar product={product} />
    </div>
  );
}
